import { isPeoplesFansDomain } from "./brandingConfig";
import { getConfigOr } from "../config";

const PEOPLESFANS_URL = getConfigOr(
  "VITE_PEOPLESFANS_URL",
  "https://peoplesfans.com"
);

console.log("PEOPLESFANS_URL", PEOPLESFANS_URL);

const NOTICES = {
  stripperfans: {
    message:
      "StripperFans is officially moving to PeoplesFans.com! Your account, content, and balance have already been safely transferred—just head over to PeoplesFans and log in normally using the same user ID and password!",
    linkLabel: "Go to PeoplesFans",
    linkHref: PEOPLESFANS_URL,
    // Users must keep seeing this until they've actually migrated off SF.
    dismissible: false,
  },
  peoplesfans: {
    message:
      "StripperFans is being decommissioned. You are now on PeoplesFans.",
    linkLabel: null,
    linkHref: null,
    // Purely informational here — no action needed, so let users clear it.
    dismissible: true,
  },
};

export const getDomainMigrationBrandKey = () =>
  isPeoplesFansDomain() ? "peoplesfans" : "stripperfans";

export const getDomainMigrationNotice = () =>
  NOTICES[getDomainMigrationBrandKey()];
